import { FileTextOutlined } from '@ant-design/icons'
import { useUserChatSummary } from '@/hooks/useUserChatSummary'
import { UserChatSummaryDrawer } from './UserChatSummaryDrawer'

interface UserChatSummaryEntryProps {
  className?: string
  userID?: string
}

export function UserChatSummaryEntry({ className, userID }: UserChatSummaryEntryProps) {
  const summaryState = useUserChatSummary(userID)

  return (
    <>
      <button
        className={className}
        disabled={!userID}
        type="button"
        aria-label="View chat summary"
        onClick={summaryState.showSummary}
      >
        <FileTextOutlined />
      </button>
      <UserChatSummaryDrawer
        error={summaryState.summaryError}
        loading={summaryState.summaryLoading}
        open={summaryState.summaryOpen}
        summary={summaryState.summary}
        onClose={summaryState.closeSummary}
      />
    </>
  )
}
